import { observable } from 'mobx';
import { ZERO } from '../utils/constant';
import Axios from 'axios';

import jz_right from '../static/panorama/sand/day/right.jpg';
import jz_left from '../static/panorama/sand/day/left.jpg';
import jz_top from '../static/panorama/sand/day/top.jpg';
import jz_bottom from '../static/panorama/sand/day/bottom.jpg';
import jz_back from '../static/panorama/sand/day/back.jpg';
import jz_front from '../static/panorama/sand/day/front.jpg';

import yard_01 from '../static/icon/yard_03/01.png';
import yard_02 from '../static/icon/yard_03/02.png';
import yard_03 from '../static/icon/yard_03/03.png';
import yard_04 from '../static/icon/yard_03/04.png';
import yard_05 from '../static/icon/yard_03/05.png';
import yard_06 from '../static/icon/yard_03/06.png';
import yard_07 from '../static/icon/yard_03/07.png';
import yard_08 from '../static/icon/yard_03/08.png';
import yard_09 from '../static/icon/yard_03/09.png';

class PanoramicMobx {
	@observable navArr = [{
		key: 'location',
		name: '区位',
		navs: ['交通路网', '教育医疗', '生活配套'],
		// panoramics: ['./vr/traffic/index.html', './vr/education/index.html', './vr/life/index.html']
		panoramics: ['./vr/traffic/tour.html', './vr/education/tour.html', './vr/life/tour.html']
	}, {
		key: 'project',
		name: '项目',
		navs: ['3号院', '2号院', '1号院'],
		panoramics: ['./vr/yard_03/index.html', './vr/yard_02/index.html', './vr/yard_01/index.html']
	}];
	@observable selectSandTableIndex = ZERO;
	@observable selectNavIndex = ZERO;
	@observable navColors = ['0 2px 2px rgba(238, 122, 64, 1)', '0 2px 2px rgba(64, 167, 238, 1)', '0 2px 2px rgba(103, 239, 135, 1)'];
	@observable panoramaImgs = [jz_right, jz_left, jz_top, jz_bottom, jz_back, jz_front];  // 全景图图片
	@observable lables = [{
		name: '1幢',
		icon: yard_01,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.6,
		worldVectorY: -0.68,
		worldVectorZ: -1
	},{
		name: '2幢',
		icon: yard_02,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.6,
		worldVectorY: -0.59,
		worldVectorZ: -1
	},{
		name: '3幢',
		icon: yard_03,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.6,
		worldVectorY: -0.49,
		worldVectorZ: -1
	},{
		name: '5幢',
		icon: yard_05,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.42,
		worldVectorY: -0.42,
		worldVectorZ: -1
	},{
		name: '6幢',
		icon: yard_06,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.38,
		worldVectorY: -0.5,
		worldVectorZ: -1
	},{
		name: '7幢',
		icon: yard_07,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.35,
		worldVectorY: -0.6,
		worldVectorZ: -1
	},{
		name: '8幢',
		icon: yard_08,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.15,
		worldVectorY: -0.49,
		worldVectorZ: -1
	},{
		name: '9幢',
		icon: yard_09,
		top: 0,
		left: 0,
		z: 0,
		worldVectorX: -0.25,
		worldVectorY: -0.42,
		worldVectorZ: -1
	}];

	getSignature = () => {
		let url = window.location.href.split('#')[0];
		Axios.get(`https://www.frontopbd.com/wxSignature?url=${url}`)
			.then(function (res) {
				let { appId, nonceStr, timestamp, signature } = res.data;
				window.wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: appId, // 必填，公众号的唯一标识
					timestamp: timestamp, // 必填，生成签名的时间戳
					nonceStr: nonceStr, // 必填，生成签名的随机串
					signature: signature,// 必填，签名
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
				});
			})
			.catch(function (err) {
			})
	}
}

export default PanoramicMobx;